import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, Flex, IconButton, useMediaQuery } from '@chakra-ui/react';
import { Fit, Layout, useRive } from '@rive-app/react-canvas';
import React from 'react';
import { useIntl } from 'react-intl';

const Content: React.FC<{ isMobile: boolean }> = ({ isMobile }) => {
    const intl = useIntl();

    const { rive, RiveComponent } = useRive({
        src: `${process.env.PUBLIC_URL}/animations/add_item.riv`,
        stateMachines: 'add_item_flow',
        artboard: isMobile ? 'attendance_list_mobile' : 'attendance_list',
        autoplay: true,
        shouldDisableRiveListeners: isMobile,
        // layout: new Layout({
        //     fit: Fit.Contain,
        // }),
    });

    rive?.setTextRunValue('subtitle_value', intl.formatMessage({ id: 'about.knowledge' }));
    return (
        <Flex
            direction="column"
            align="center"
            justify="center"
            h={{ base: '750px', md: '400px', lg: '700px', xl: '800px' }}
            p={5}
            mt={{ base: -130, md: -180, lg: -250 }}
            position="relative"
        >
            {/* IconButton centered and overlapping the box */}
            <Box
                position="absolute"
                top="calc(0% + 10px)" // Adjust overlap as needed
                left="50%"
                transform="translate(-50%, -50%)"
                zIndex={2}
            >
                <IconButton
                    icon={<ChevronDownIcon boxSize={10} color={'surface.500'} />}
                    aria-label="scroll down"
                    colorScheme="primaryAbout"
                    onClick={() => {
                        const box = document.getElementById('scroll-target');
                        if (box) {
                            box.scrollIntoView({ behavior: 'smooth' });
                        }
                    }}
                    size="lg"
                />
            </Box>

            {/* Blurred glass box as background */}
            <Box
                id="scroll-target"
                backdropFilter={{ base: 'blur(10px)', md: 'blur(20px)' }}
                backgroundColor={'rgba(29, 27, 32, 0.4)'}
                width="100%"
                maxW={{ base: '100%', md: '1300px' }}
                margin="auto"
                borderRadius={50}
                pt={5}
                position="relative"
                overflow="hidden"
                display="flex"
                alignItems="center"
                justifyContent="center"
                h="100%"
            >
                {/* Rive animation fills the box */}
                <Box width="100%" height="100%">
                    <RiveComponent style={{ width: '100%', height: '100%' }} />
                </Box>
            </Box>
        </Flex>
    );
};

const AnimatedIntro: React.FC = () => {
    const [isMobile] = useMediaQuery('(max-width: 650px)');

    return isMobile ? (
        <Content key={'mobile_animated_intro'} isMobile={isMobile} />
    ) : (
        <Content key={'animated_intro'} isMobile={isMobile} />
    );
};

export default AnimatedIntro;
